import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { ShieldAlert, FlaskConical, LogOut, Menu, X, Inbox, Package, Ticket, Gift, Mail, FileText, Settings, ShoppingBag, Repeat, Percent, BookOpen, Upload, Sparkles, Quote, Users, BarChart3, ContactRound, Send, Receipt, Activity, MailOpen } from "lucide-react";
import { AdminSearch } from "../components/AdminSearch";
import { Toaster } from "sonner";

const items = [
  { to: "/admin/stats", label: "Statistiques", icon: BarChart3 },
  { to: "/admin/contacts", label: "Contacts", icon: ContactRound },
  { to: "/admin", label: "Correspondances", icon: Inbox, end: true },
  { to: "/admin/coffrets", label: "Coffrets à envoyer", icon: Package },
  { to: "/admin/codes", label: "Codes", icon: Ticket },
  { to: "/admin/gift-cards", label: "Cartes cadeaux", icon: Gift },
  { to: "/admin/subscriptions", label: "Abonnements", icon: Repeat },
  { to: "/admin/courriers", label: "Courriers à envoyer", icon: MailOpen },
  { to: "/admin/mailclub", label: "Club de Lettres", icon: MailOpen },
  { to: "/admin/club-tests", label: "Club — tests & Stripe", icon: FlaskConical },
  { to: "/admin/promo-codes", label: "Codes promo", icon: Percent },
  { to: "/admin/orders", label: "Commandes", icon: ShoppingBag },
  { to: "/admin/invoices", label: "Factures", icon: Receipt },
  { to: "/admin/leads", label: "Leads (aimants)", icon: Users },
  { to: "/admin/newsletter-envoi", label: "Envoyer newsletter", icon: Send },
  { to: "/admin/import", label: "Importer clientes", icon: Upload },
  { to: "/admin/programme-tracking", label: "Suivi programmes", icon: Activity },
  { to: "/admin/emails", label: "Emails auto", icon: Mail },
  { to: "/admin/programme-emails", label: "Emails programme", icon: BookOpen },
  { to: "/admin/testimonials", label: "Témoignages", icon: Quote },
  { to: "/admin/social", label: "Contenu social IA", icon: Sparkles },
  { to: "/admin/pages", label: "Pages", icon: FileText },
  { to: "/admin/settings", label: "Réglages", icon: Settings },
  { to: "/admin/systeme", label: "Système & alertes", icon: ShieldAlert },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(false); }, [loc.pathname]);
  const current = items.find(it => it.end ? loc.pathname === it.to : loc.pathname.startsWith(it.to) && it.to !== "/admin")?.label || "Back-office";
  const email = localStorage.getItem("rdv_admin_email");
  function logout() {
    localStorage.removeItem("rdv_token");
    localStorage.removeItem("rdv_admin_email");
    nav("/admin/login");
  }
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex">
      <Toaster position="top-center"/>
      <header className="md:hidden fixed top-0 inset-x-0 z-40 h-14 bg-[#F5F0E6] border-b border-[#E8DCC8] flex items-center justify-between px-4">
        <button data-testid="admin-menu-toggle" onClick={() => setOpen(o => !o)} className="p-2 -ml-2 text-[#2C2621]" aria-label="Menu">
          {open ? <X size={22}/> : <Menu size={22}/>}
        </button>
        <p className="font-serif text-base text-[#2C2621] truncate">{current}</p>
        <span className="w-8"/>
      </header>
      {open && <div className="md:hidden fixed inset-0 z-40 bg-black/30" onClick={() => setOpen(false)}/>}
      <aside data-testid="admin-sidebar" className={`fixed md:static inset-y-0 left-0 z-50 w-72 md:w-64 bg-[#F5F0E6] border-r border-[#E8DCC8] flex flex-col transform transition-transform md:transform-none overflow-y-auto ${open ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}>
        <div className="p-6 border-b border-[#E8DCC8]">
          <p className="font-hand text-xl text-[#A3876A]">Back-office</p>
          <p className="font-serif text-lg text-[#2C2621]">Les RDV de l'écriture</p>
        </div>
        <AdminSearch/>
        <nav className="flex-1 p-4 space-y-1">
          {items.map(it => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={`nav-admin-${it.to.split("/").pop() || "home"}`}
              className={({isActive}) => `flex items-center gap-3 px-3 py-3 md:py-2.5 text-[15px] md:text-sm transition-colors ${isActive ? "bg-[#DCCBBA] text-[#2C2621]" : "text-[#4A4036] hover:bg-[#E8DCC8]"}`}>
              <it.icon size={16}/> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#E8DCC8]">
          <p className="text-xs text-[#7C7064] mb-2">{email}</p>
          <button data-testid="admin-logout" onClick={logout} className="flex items-center gap-2 text-sm text-[#A86962] hover:underline">
            <LogOut size={14}/> Déconnexion
          </button>
        </div>
      </aside>
      <main className="admin-main flex-1 min-w-0 p-4 pt-20 md:p-8 md:pt-8 overflow-auto"><Outlet/></main>
    </div>
  );
}
